import { useStaticQuery, graphql } from "gatsby"

const useLayoutQuery = () => {
  return useStaticQuery(graphql`
    fragment WpSeo on WpPostTypeSEO {
      metaDesc
      metaKeywords
      metaRobotsNofollow
      opengraphAuthor
      opengraphDescription
      opengraphImage {
        localFile {
          publicURL
        }
      }
      opengraphModifiedTime
      opengraphPublishedTime
      opengraphPublisher
      opengraphSiteName
      opengraphTitle
      opengraphType
      opengraphUrl
      readingTime
      schema {
        articleType
        pageType
        raw
      }
      title
      twitterDescription
      twitterImage {
        localFile {
          publicURL
        }
      }
      twitterTitle
    }
    fragment ArticleCard on WpPost {
      id
      uri
      title
      date(formatString: "ddd DD MMMM")
      categories {
        nodes {
          name
          slug
        }
      }
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData (
                width: 1000
              )
            }
          }
        }
      }
      acf {
        mediaExcerpt
        podcast
        externalLink
        via
      }
    }
    fragment TeamCard on WpTeam {
      id
      uri
      title
      acf {
        profileImage {
          localFile {
            childImageSharp {
              gatsbyImageData (
                width: 1000
              )
            }
          }
        }
        bio
        role
        quote
        linkedin
        email
      }
    }
    fragment ServiceCard on WpService {
      id
      uri
      title
      acf {
        icon
        snippet
      }
    }
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      wp {
        generalSettings {
          title
          url
        }
      }
    }
  `)
}

export default useLayoutQuery